import { useEffect, useState } from 'react'
import { ajax } from '@src/utils/ajax'

import { getFilterSearchParameters } from '../helpers'
import { RequestPayload } from '../types'

export const useData = () => {
  const [data, setData] = useState<RequestPayload | undefined>()
  const [isFetching, setIsFetching] = useState(false)

  const fetchData = () => {
    setIsFetching(true)

    const filterParams = getFilterSearchParameters()

    ajax
      .get<RequestPayload>('/analitika_avito/graphics', {
        params: filterParams
      })
      .then(response => {
        setData(response.data)
        setIsFetching(false)
      })
      .catch(() => {
        setIsFetching(false)
      })
  }

  useEffect(fetchData, [])

  return {
    data,
    isFetching,
    fetchData
  }
}
